
import ClickAwayListener from 'react-click-away-listener';

export default ClickAwayListener;
